import Box from '@mui/material/Box'

import Button from '@mui/material/Button'

const primaryButtonHoverBG = 'linear-gradient(270deg, #00B596 0%, #0A78CD 100%)'

const sx = {
  main: {},
  navReg: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: '100%',
    overflowY: 'auto',

    '.nav-logo': {
      width: '100%',
      textAlign: 'right',

      img: {
        margin: '20px 20px',
        width: '60px',
      },
    },

    '.nav-sub-logo': {
      alignSelf: 'flex-start',
      img: {
        width: '100%',
        height: '100%',
        padding: '0 30px',
      },
    },

    '.nav-title': {
      textAlign: 'left',
      margin: '25px 25px',
      h6: {
        fontWeight: '600',
        fontFamily: 'Poppins',
        color: '#25245f',
        fontSize: '24px',
        lineHeight: '30px',
        marginBottom: '30px',
      },
      p: {
        color: '#25245F',
        fontWeight: '400',
        fontSize: '16px',
        lineHeight: '24px',
      },
    },
    '.nav-disclosure': {
      a: {
        color: '#0099FF',
        fontWeight: '400',
        fontSize: '12px',
        fontFamily: 'poppins',
        textTransform: 'capitalize',
        cursor: 'pointer',
      },
      marginTop: 'auto',
    },
  },

  button: {
    background: 'linear-gradient(270deg, rgb(0, 203, 169) 0%, rgb(0, 153, 255) 100%)',
    borderRadius: '30px',
    fontSize: '15px',
    lineHeight: '20px',
    fontWeight: '700',
    paddingLeft: '30px',
    paddingRight: '30px',
    height: '40px',
    textTransform: 'none',
    margin: '26px 0',
    minWidth: '200px',
    color: 'white',
    // marginTop: "230px",
    '&:hover': {
      background: primaryButtonHoverBG,
    },
  },
  cta: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    fontSize: '14px',

    '.cta-label': {
      color: '#25245F',
    },

    '.cta-value': {
      fontWeight: 'bold',
    },
  },
}

export default function NavCard({ imageURL, title, body, buttonText, onClick, onDisclosureClick, navData }) {
  return (
    <Box sx={sx.navReg}>
      <div className="nav-title">
        <h6>{title}</h6>
        <p>{body}</p>
      </div>

      {navData && (
        <Box sx={sx.cta}>
          <div>
            <span className="cta-label">Amount</span>
            <br />
            <span className="cta-value">{navData.fundingAmount}</span>
          </div>
          <div>
            <span className="cta-label">Cost</span>
            <br />
            <span className="cta-value">{navData.cost}</span>
          </div>
          <div>
            <span className="cta-label">Speed</span>
            <br />
            <span className="cta-value">{navData.fundingSpeed}</span>
          </div>
        </Box>
      )}

      <Button sx={sx.button} className="Cta-button" data-nav-cta-button onClick={onClick}>
        {buttonText}
      </Button>
    </Box>
  )
}
